import { PaginatedDto, PaginatedQuery } from "@core/data/dto/paginated.dto";
import { EntityApiKeyDto } from "@entity-api-keys/data/dto/entity-api-key.dto";
import { Type } from "class-transformer";
import { IsArray } from "class-validator";

export class EntityApiKeysDto extends PaginatedDto {
    @IsArray()
    @Type(() => EntityApiKeyDto)
    results!: EntityApiKeyDto[];
}

export type EntityApiKeysQuery = PaginatedQuery & {
    search?: string;
    entity?: number;
    created_after?: string;
    created_before?: string;
    is_active?: boolean;
    scopes?: string;
};
